import { useCompany, useDashboard, useOnFirstRender } from 'hooks';
import useMediaQuery from 'hooks/useMediaQuery';
import React from 'react';
import { Container } from 'ui/components/styled';
import device from 'ui/theme/device';
import { Card } from './styled';
import { MobileCardsContainer } from './styled/MobileCardsContainer';

export const Statistics = ({
  variant,
  search,
  activeStatus,
  onStatusChange,
  fetchOnFirstRender = true,
}) => {
  const [status, setStatus] = React.useState(activeStatus);
  const { stats, fetchStatistics } = useDashboard();
  const { activeCompany, companiesLoaded } = useCompany();
  const isFirstRender = useOnFirstRender();
  const isLarge = useMediaQuery(device.large);

  const handleCardClick = (value) => {
    if (value === status) {
      value = '';
    }
    setStatus(value);
    if (onStatusChange) {
      onStatusChange(value);
    }
  };

  React.useEffect(() => {
    if (activeStatus !== status) {
      setStatus(activeStatus);
    }
  }, [activeStatus]);

  React.useEffect(() => {
    if (isFirstRender && !fetchOnFirstRender) return;

    if (companiesLoaded) {
      fetchStatistics(search);
    }
  }, [companiesLoaded, activeCompany]);

  const variantType = isLarge ? variant : 'small';

  const cards = (
    <>
      <Card
        dataCy="statistics-success"
        variant={variantType}
        label="Success"
        value={stats?.success}
        isActive={!status ? undefined : status === 'success'}
        onClick={() => handleCardClick('success')}
        bg="#00AA22"
        mr="s"
      />
      <Card
        dataCy="statistics-failed"
        variant={variantType}
        label="Failed"
        value={stats?.failed}
        isActive={!status ? undefined : status === 'failed'}
        onClick={() => handleCardClick('failed')}
        bg="#FF0000"
        mr="s"
      />
      <Card
        dataCy="statistics-warning"
        variant={variantType}
        label="Warning"
        value={stats?.warning}
        isActive={!status ? undefined : status === 'warning'}
        onClick={() => handleCardClick('warning')}
        bg="#F5D946"
        mr="s"
      />
      <Card
        dataCy="statistics-late"
        variant={variantType}
        label="Late"
        value={stats?.late}
        isActive={!status ? undefined : status === 'late'}
        onClick={() => handleCardClick('late')}
        bg="#8900FF"
        mr="s"
      />
      <Card
        dataCy="statistics-uninitialized"
        variant={variantType}
        label="Uninitialized"
        value={stats?.unknown}
        isActive={!status ? undefined : status === 'unknown'}
        onClick={() => handleCardClick('unknown')}
        bg="#888"
      />
    </>
  );

  return isLarge ? (
    <Container
      data-testid="stats-container"
      flexDirection="row"
      width={variant === 'small' ? 'auto' : '100%'}
      height="auto"
      px="m"
    >
      {cards}
    </Container>
  ) : (
    <MobileCardsContainer data-testid="stats-container" px="m">
      {cards}
    </MobileCardsContainer>
  );
};
